"use strict";
var $ = require("jquery");
var _ = require("lodash");
var crosstab = require("crosstab");
var FingerprintJS = require("fingerprint");
var ajaxUtils_1 = require("./ajaxUtils");
var localStorageUtils_1 = require("../utils/localStorageUtils");
var WebSocketUtils = (function () {
    function WebSocketUtils() {
    }
    WebSocketUtils.isPushDisabled = function () {
        var value = localStorageUtils_1.default.get(this.pushDisabledKey);
        if (value === undefined || value === null) {
            return false;
        }
        return value;
    };
    WebSocketUtils.isConnected = function () {
        return localStorageUtils_1.default.get(this.pushTokenIdKey);
    };
    WebSocketUtils.getPushTokenId = function () {
        return localStorageUtils_1.default.get(this.pushTokenIdKey);
    };
    WebSocketUtils.setPushTokenId = function (id) {
        localStorageUtils_1.default.set(this.pushTokenIdKey, id);
    };
    WebSocketUtils.getPushToken = function () {
        return localStorageUtils_1.default.get(this.pushTokenKey + "." + app.userId);
    };
    WebSocketUtils.savePushToken = function (token) {
        localStorageUtils_1.default.set(this.pushTokenKey + "." + app.userId, token);
        localStorageUtils_1.default.set(this.pushTokenUserIdKey, app.userId);
    };
    WebSocketUtils.disablePushNotifications = function () {
        localStorageUtils_1.default.set(this.pushDisabledKey, true);
    };
    WebSocketUtils.sendTokenToServer = function (refreshedToken, onSuccessCallback) {
        var _this = this;
        var savedToken = this.getPushToken();
        var lastUserId = localStorageUtils_1.default.get(this.pushTokenUserIdKey);
        var isSynced = savedToken === refreshedToken && lastUserId === app.userId;
        if (isSynced) {
            console.log("Token already sent to server so won\'t send it again unless it changes");
            return;
        }
        var tokenId = this.getPushTokenId();
        ajaxUtils_1.AjaxUtils.post("account/updateFirebaseToken", {
            id: tokenId,
            token: refreshedToken
        }).done(function (result) {
            if (result.isSuccessful) {
                localStorageUtils_1.default.set(_this.pushTokenIdKey, result.data.id);
                _this.savePushToken(refreshedToken);
                if (onSuccessCallback) {
                    onSuccessCallback();
                }
            }
            else {
                console.error("UpdateFirebaseToken error: ", result.messages[0]);
            }
        });
    };
    WebSocketUtils.registerServiceWorker = function () {
        var _this = this;
        // Удаляем OneSignal
        try {
            if (navigator && navigator.serviceWorker) {
                var oneSignalUninstalledKey_1 = "oneSignalUninstalled";
                var oneSignalUninstalled = localStorageUtils_1.default.get(oneSignalUninstalledKey_1);
                if (oneSignalUninstalled) {
                    console.log("OneSignalSDKWorker was already uninstalled.");
                }
                else {
                    navigator.serviceWorker.getRegistrations().then(function (registrations) {
                        if (!registrations.length) {
                            console.log("No serviceWorker registrations found.");
                            localStorageUtils_1.default.set("OneSignalUninstalled", true);
                            return;
                        }
                        for (var _i = 0, registrations_1 = registrations; _i < registrations_1.length; _i++) {
                            var registration = registrations_1[_i];
                            var scriptURL = registration.installing
                                ? registration.installing.scriptURL
                                : registration.waiting
                                    ? registration.waiting.scriptURL
                                    : registration.active
                                        ? registration.active.scriptURL
                                        : "";
                            console.log("ScriptURL: ", scriptURL);
                            if (scriptURL && scriptURL.indexOf("OneSignalSDKWorker") !== -1) {
                                console.log("OneSignalSDKWorker was found.");
                                registration.unregister().then(function (isOk) {
                                    if (isOk) {
                                        console.log("Successfully unregistered OneSignalSDKWorker");
                                    }
                                    else {
                                        console.log("Failed to unregister OneSignalSDKWorker");
                                    }
                                });
                            }
                        }
                        localStorageUtils_1.default.set(oneSignalUninstalledKey_1, true);
                    });
                }
            }
        }
        catch (ex) {
            try {
                console.error(ex);
            }
            catch (ex2) { }
        }
        try {
            var app = window["at_firebaseApp"];
            if (app) {
                return;
            }
            var firebaseConfig = {
                apiKey: "AIzaSyA0Sykval4lnNmJLFM5eY0_dCfvVJZmgvE",
                //authDomain: "authortoday-b4da3.firebaseapp.com",
                //databaseURL: "https://authortoday-b4da3.firebaseio.com",
                projectId: "authortoday-b4da3",
                //storageBucket: "authortoday-b4da3.appspot.com",
                messagingSenderId: "650481789785",
                appId: "1:650481789785:web:5ccbb36a4d7b0346"
            };
            // Initialize Firebase
            window["at_firebaseApp"] = firebase.initializeApp(firebaseConfig);
            // Retrieve Firebase Messaging object.
            var messaging = firebase.messaging();
            // Handle incoming messages. Called when:
            // - a message is received while the app has focus
            // - the user clicks on an app notification created by a service worker
            //   `messaging.setBackgroundMessageHandler` handler.
            messaging.onMessage(function (payload) {
                console.log("Push received. ", payload);
                var iconUrl = payload.data.largeIconUrl || window["app"].rootUrl + "dist/favicons/android-chrome-192x192.png";
                var notification = new Notification(payload.data.contentTitle, {
                    body: payload.data.contentText,
                    dir: "auto",
                    tag: "PMMessage",
                    icon: iconUrl
                });
                if (payload.data.url) {
                    var url = window["app"].rootUrl + payload.data.url;
                    if (url.indexOf(location.origin) === -1) {
                        url = location.origin + url;
                    }
                    notification.onclick = function () {
                        window.open(url);
                        notification.close();
                    };
                }
            });
            messaging.getToken({ vapidKey: "BHoD83g9Ie39LDASicR38lhqzF7t4hMTdJgpewwftIUUv4dvEeTeuCA-aOB-qWrAmNDwDsTXSaAjHURQ6p6efqE" })
                .then(function (currentToken) {
                if (currentToken) {
                    _this.sendTokenToServer(currentToken);
                }
                else {
                    // Show permission request.
                    console.log("No Instance Push ID token available. Request permission to generate one.");
                }
            }).catch(function (err) {
                console.log("An error occurred while retrieving token. ", err);
            });
        }
        catch (ex) {
            try {
                console.error(ex);
            }
            catch (ex2) { }
        }
    };
    WebSocketUtils.initCrossTab = function () {
        var _this = this;
        try {
            // Проверяем заполненность LocalStorage
            try {
                var localStorageSize = JSON.stringify(localStorage).length;
                if (localStorageSize > 3 * 1024 * 1024) {
                    console.log("LocalStorage size is TOO big: ", localStorageSize);
                    localStorage.clear();
                    console.log("LocalStorage was cleared.");
                }
            }
            catch (ex) {
                console.log(ex);
            }
            // Если пользователь не авторизован, ничего не делаем.
            if (!window["app"].isAuthenticated)
                return;
            FingerprintJS.load().then(function (fp) { return fp.get(); }).then(function (result) {
                ajaxUtils_1.AjaxUtils.post(app.statsApiUrl + "account/track-last-activity", { id: result.visitorId }, true);
            });
            // if (window["app"].disableWebSockets) return;
            // Если уже была инициализация, то это PJAX запрос. Больше ничего делать не нужно.
            if (window["crosstab"])
                return;
            window["crosstab"] = crosstab;
            if (!("Notification" in window)) {
                this.html5NotificationSupported = false;
                console.log("HTML5 Notifications unsupported.");
            }
            else {
                this.html5NotificationSupported = true;
            }
            if (this.html5NotificationSupported) {
                this.html5NotificationPermision = window["Notification"].permission;
            }
            else {
                this.html5NotificationPermision = "denied";
            }
            if (this.html5NotificationPermision === "default") {
                window["Notification"].requestPermission(function (permission) {
                    _this.html5NotificationPermision = permission;
                });
            }
            if (!crosstab.supported) {
                console.error("Crosstab IS NOT SUPPORTED.");
                return;
            }
            crosstab.off("activePage");
            crosstab.on("activePage", function (message) {
                console.log("Crosstab | activePage:", message.data);
                window["app"].activePage = message.data;
            });
            crosstab.off("focusPage");
            crosstab.on("focusPage", function (message) {
                window.focus();
                if (message.data && message.data.url) {
                    window.location.href = message.data.url;
                }
            });
            crosstab.off("unfocusPage");
            crosstab.on("unfocusPage", function (message) {
                app.activePage = null;
            });
            crosstab.on("", function (message) {
            });
            crosstab.broadcast("activePage", window.location.href);
            $(window).on("focus", function () {
                crosstab.broadcast("activePage", window.location.href);
            });
            $(window).on("blur beforeunload", function () {
                crosstab.broadcast("unfocusPage", window.location.href);
                app.activePage = null;
            });
        }
        catch (e) {
            console.error(e);
        }
    };
    WebSocketUtils.getPMTabId = function () {
        var tabs = crosstab.util.tabs;
        var pmTabId = null;
        _.forOwn(tabs, function (v, k) {
            if (v.url && v.url.indexOf("/pm") !== -1) {
                pmTabId = v.id;
            }
        });
        return pmTabId;
    };
    WebSocketUtils.html5NotificationSupported = false;
    WebSocketUtils.pushDisabledKey = "pushDisabled";
    WebSocketUtils.pushTokenIdKey = "pushToken.id";
    WebSocketUtils.pushTokenKey = "pushToken";
    WebSocketUtils.pushTokenUserIdKey = "pushToken.userId";
    return WebSocketUtils;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = WebSocketUtils;
//# sourceMappingURL=webSocketUtils.js.map